import { Outlet } from 'react-router'
import { TabLink } from '@/components/commons/tab-link'
import { ButtonLinkBrand } from '@/components/ui/button-link-brand'
import { useAuthStore } from '@/features/auth/store/store'
import { useGetMMCounts } from '@/features/luxe-submissions/queries/use-get-mm-counts'
import { routes } from '@/routes'
import { useTranslation } from '@/translations/i18n'

function LuxeSubmissionsMMOverviewLayout() {
	const { t } = useTranslation()
	const { data: mmCounts } = useGetMMCounts()
	const user = useAuthStore((state) => state.user)
	const isMarketingManager = user?.role === 'marketing_manager'
	return (
		<div className='flex flex-1 flex-col overflow-hidden'>
			{/* Header */}
			<div className='flex items-center justify-between border-neutral-200 border-b px-10 pt-6 pb-6'>
				<h1 className='font-medium text-lg text-neutral-900'>
					{t('luxe_submissions:mm_overview')}
				</h1>
				{isMarketingManager && (
					<ButtonLinkBrand
						size='sm'
						to={routes.LUXE_SUBMISSIONS_SUBMISSION.handle.fullPath}
					>
						{t('luxe_submissions:submit_new_listing')}
					</ButtonLinkBrand>
				)}
			</div>

			{/* Tabs */}
			{isMarketingManager && (
				<div className='flex items-center gap-1 border-neutral-300 border-b px-10 pt-6'>
					<TabLink
						count={mmCounts?.data?.submissions}
						label={t('luxe_submissions:mm_submissions')}
						to={
							routes.LUXE_SUBMISSIONS_MM_SUBMISSIONS.handle
								.fullPath
						}
					/>
					<TabLink
						count={mmCounts?.data?.parkingLot}
						label={t('luxe_submissions:mm_vetting_complete')}
						to={
							routes.LUXE_SUBMISSIONS_MM_PARKING_LOT.handle
								.fullPath
						}
					/>
					<TabLink
						label={t('luxe_submissions:mm_data_overview')}
						to={
							routes.LUXE_SUBMISSIONS_MM_DATA_OVERVIEW.handle
								.fullPath
						}
					/>
				</div>
			)}

			{/* Content */}
			<div className='flex flex-1 flex-col overflow-hidden'>
				<Outlet />
			</div>
		</div>
	)
}

export { LuxeSubmissionsMMOverviewLayout }
